module.exports = __webpack_public_path__ + "static/media/vtr_car.fa3672e4.svg";